import { Injectable } from '@angular/core';
import {
  BaseUserModel,
  UserPermissionsModel,
  UserRolesModel,
} from '../../Models/userModel';
import { CookieService } from 'ngx-cookie-service';
import { jwtDecode } from 'jwt-decode';
import { environment } from 'src/app/environments/environment';
import { UserApiService } from './user-api-service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userData: BaseUserModel | null = null;
  userRoles: UserRolesModel[] = [];
  LoginUrl: string = environment.companyWebBaseUrl;

  constructor(
    private cookieService: CookieService,
    private userapiservice: UserApiService
  ) {}

  getSessionStorageItem() {
    const accessToken = this.cookieService.get('accessToken');
    const refreshToken = this.cookieService.get('refreshToken');
    if (accessToken || refreshToken) {
      this.saveUserInfo(accessToken); // save user info
    }
  }

  getAuthToken(): string | null {
    return this.cookieService.get('accessToken') || null;
  }

  decodeJwt(token: string): any {
    try {
      const decodedToken = jwtDecode(token);

      const cleanedToken = this.removeCustomPrefix(decodedToken);

      return cleanedToken;
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  }

  removeCustomPrefix(tokenData: Record<string, any>): Record<string, any> {
    const cleanedData: Record<string, any> = {};

    Object.keys(tokenData).forEach((key) => {
      const newKey = key.startsWith('custom:')
        ? key.replace('custom:', '')
        : key;
      cleanedData[newKey] = tokenData[key];
    });

    return cleanedData;
  }

  saveUserInfo(token: string) {
    const decodedToken = this.decodeJwt(token);

    if (decodedToken) {
      const { userid, companyid, fullname, role } = decodedToken;

      const user = new BaseUserModel();
      user.userId = userid;
      user.companyId = companyid;
      user.fullName = fullname;
      user.roles = role;

      const user1 = JSON.stringify(user);
      localStorage.setItem('user', user1);
    }
  }
  getUserFromLocalStorage(): BaseUserModel | null {
    const userDetails = localStorage.getItem('user');
    if (userDetails) {
      try {
        return JSON.parse(userDetails) as BaseUserModel;
      } catch (error) {
        console.error('Error parsing userDetails from localStorage:', error);
        return null;
      }
    }
    return null;
  }

  async getUserRolesandPerm(): Promise<UserPermissionsModel[]> {
    this.userData = this.getUserFromLocalStorage();

    if (this.userData) {
      const data = await this.userapiservice
        .getUserRoleDetails(this.userData.userId)
        .toPromise();
      if (data) {
        this.userRoles = data as UserRolesModel[];
        const appRoles = this.userRoles?.filter((role) => role.appId === 4);

        const userPermissions: UserPermissionsModel[] = [];
        appRoles?.forEach((role) => {
          userPermissions.push(...role.permissions);
        });

        return userPermissions;
      }
    }

    return [];
  }

  logout(): void {
    // Set logout cookie for shared domain
    const domain = environment.domainName;
    localStorage.clear();
    sessionStorage.clear();
    this.cookieService.deleteAll();
    this.cookieService.set('logoutEvent', '1', 1 / 144, '/', domain); // 10 minutes expiry
    let companyweburl = environment.companyWebBaseUrl;
    window.location.href = `${companyweburl}/shared/login`;
  }
}
